'use client';

import { useEffect, useState } from 'react';
import { notFound, useParams } from 'next/navigation';
import type { AdoptionQuizThemeMode } from '../../../../theme/shelterPaletteCatalog';
import { MatchingPocPage } from '../../../../features/matching-poc/pages/MatchingPocPage';
import { fetchPublicShelterLookup } from '../../../../features/adopt-quiz/api/publicSheltersApi';
import { AdoptPublicQuizThemeRoot } from '../../../../features/adopt-quiz/components/AdoptPublicQuizThemeRoot';

export default function AdoptShelterQuizPage() {
  const params = useParams();
  const rawKey = params?.shelterKey;
  const segment =
    typeof rawKey === 'string' ? rawKey : Array.isArray(rawKey) ? rawKey[0] : '';

  const [resolved, setResolved] = useState<{
    shelterId: string;
    shelterDisplayName?: string | null;
    shelterAdoptionFormUrl?: string | null;
    adoptionQuizTheme: {
      paletteId: string;
      mode: AdoptionQuizThemeMode;
    } | null;
  } | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
    setResolved(null);
    if (!segment) return;
    let cancelled = false;
    fetchPublicShelterLookup(segment)
      .then((dto) => {
        if (cancelled) return;
        setResolved({
          shelterId: dto.id,
          shelterDisplayName: dto.name,
          shelterAdoptionFormUrl: dto.shelterAdoptionFormUrl,
          adoptionQuizTheme: dto.adoptionQuizTheme,
        });
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [segment]);

  if (!segment) {
    notFound();
  }

  if (failed) {
    notFound();
  }

  if (!resolved) {
    return (
      <AdoptPublicQuizThemeRoot theme={null}>
        <div className='mx-auto max-w-lg px-4 py-16 text-center text-sm text-muted-foreground'>
          Loading…
        </div>
      </AdoptPublicQuizThemeRoot>
    );
  }

  return (
    <AdoptPublicQuizThemeRoot theme={resolved.adoptionQuizTheme}>
      <div className='mx-auto flex w-full max-w-7xl flex-1 flex-col px-4 py-6 sm:px-6 sm:py-8 lg:px-8'>
        <MatchingPocPage
          shelterMatchContext={{
            shelterId: resolved.shelterId,
            shelterDisplayName: resolved.shelterDisplayName,
            shelterAdoptionFormUrl: resolved.shelterAdoptionFormUrl,
          }}
        />
      </div>
    </AdoptPublicQuizThemeRoot>
  );
}
